/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Row, Column } from '../../../../../styles/Grid';
import Picture from '../../../../ui/Picture';
import { Breakpoints } from '../../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../../utils/constants';
import {
  leftImageColumns,
  leftImageContainer,
  rightImageColumns,
  rightImageContainer,
  relativeElement,
  rowCss,
} from './index.styles';
import { pictureStyles, imageStyles } from '../../index.styles';

const imageRightSizes = {
  [Breakpoints.xl]: {
    hidden: true,
  },
  [Breakpoints.lg]: {
    hidden: true,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '33:25',
    gravity: 'auto:subject',
    width: 328,
    height: 247,
  },
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '21:16',
    gravity: 'auto:subject',
    width: 210,
    height: 158,
  },
};

const imageLeftSizes = {
  [Breakpoints.xl]: {
    hidden: true,
  },
  [Breakpoints.lg]: {
    hidden: true,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '22:15',
    gravity: 'auto:subject',
    width: 328,
    height: 227,
  },
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '10:7',
    gravity: 'auto:subject',
    width: 210,
    height: 147,
  },
};

const FirstTabImage = (imageLeft, imageRight) => (
  <Row key="firstTabImage" css={rowCss}>
    <Column css={rightImageColumns} cols={{ sm: 4, md: 4 }}>
      <div css={relativeElement}>
        <div css={rightImageContainer}>
          <Picture
            image={imageRight}
            imageSizes={imageRightSizes}
            pictureCss={pictureStyles}
            imageCss={imageStyles}
          />
        </div>
      </div>
    </Column>
    <Column
      css={leftImageColumns}
      cols={{ sm: 4, md: 4 }}
      offsets={{ sm: 2, md: 3 }}
    >
      <div css={relativeElement}>
        <div css={leftImageContainer}>
          <Picture
            image={imageLeft}
            imageSizes={imageLeftSizes}
            pictureCss={pictureStyles}
            imageCss={imageStyles}
          />
        </div>
      </div>
    </Column>
  </Row>
);

FirstTabImage.displayName = 'RegusTabs/SmImages/FirstTabImage';

export default FirstTabImage;
